import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=6319f3ee&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319f3ee",
  null
  
)

export default component.exports